export default class Animations {
    constructor() {
        this.blocks = [];
        this.parallaxBlocks = [];

        this.blockObserver = null;
        this.parallaxBlockObserver = null;
    }

    init() {
        if ($('.animate').length) {
            this.initAnimatedBlocks();
        }

        if ($('.parallax-item').length) {
            this.initParallaxBlocks();
        }

        window.updateAnimations = this.updateAnimations.bind(this);
    }

    updateAnimations() {
        this.destroy();
        this.initAnimatedBlocks();
        this.initParallaxBlocks();
    }

    initAnimatedBlocks() {
        this.blockObserver = new IntersectionObserver(function(entries) {
            entries.forEach(entry => {
                const element = entry.target;
                if (entry.isIntersecting) {
                    element.classList.add('animated');
                }
            });
        });

        this.blocks = document.querySelectorAll('.animate');

        if (window.matchMedia('(min-aspect-ratio: 22/10)').matches) {
            this.blocks.forEach(block => {
                block.classList.add('animated');
            });
        } else {
            this.blockObserver = new IntersectionObserver(function(entries) {
                entries.forEach(entry => {
                    const element = entry.target;
                    if (entry.isIntersecting) {
                        element.classList.add('animated');
                    }
                });
            });

            this.blocks.forEach(block => {
                this.blockObserver.observe(block);
            });
        }
    }

    initParallaxBlocks() {
        const animations = this;

        const options = {
            root: null,
            rootMargin: '0px 0px',
            threshold: 0
        };

        this.parallaxBlocks = document.querySelectorAll('.parallax-item');

        this.parallaxBlockObserver = new IntersectionObserver(function(entries) {
            entries.forEach(entry => {
                const element = entry.target;
                if (entry.isIntersecting) {
                    window.addEventListener('scroll', function() {
                        animations.animateParallaxItem(element);
                    }, false);
                } else {
                    window.removeEventListener('scroll', function() {
                        animations.animateParallaxItem(element);
                    }, false);
                }
            });
        });

        this.parallaxBlocks.forEach(block => {
            this.parallaxBlockObserver.observe(block);
        }, options);
    }

    animateParallaxItem(element) {
        const winScrollTop = window.scrollY;
        const shiftDistance = winScrollTop * -0.25;
        $(element).css('transform', 'translateY(' + shiftDistance + 'px)');
    }

    destroy() {
        if (this.blocks !== undefined && this.blocks.length) {
            this.blocks.forEach(block => {
                this.blockObserver.unobserve(block);
            });
        }

        if (this.parallaxBlocks !== undefined && this.parallaxBlocks.length) {
            this.parallaxBlocks.forEach(block => {
                this.parallaxBlockObserver.unobserve(block);
            });
        }
    }
}
